import { render, staticRenderFns } from "./signUpTrain.vue?vue&type=template&id=56691032&scoped=true&"
import script from "./signUpTrain.vue?vue&type=script&lang=js&"
export * from "./signUpTrain.vue?vue&type=script&lang=js&"
import style0 from "./signUpTrain.vue?vue&type=style&index=0&id=56691032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56691032",
  null
  
)

export default component.exports